export interface PaginatedProvidersResponse {
  data: Provider[];
  total: number;
  page?: number;
  limit?: number;
  pages?: number;
}

export interface Provider {
  id: number;
  provider_name: string;
  business_name: string;
  ruc: string;
  RUC?: string;
  address: string;
  city?: string | null;
  phone: string;
  email: string;
  bank_accounts: Omit<BankAccount, 'id'>[];
  is_active?: boolean;
  is_deleted?: boolean;
  user_data: UserData;
  created_at?: string;
  updated_at?: string;
  country?: string | null;
  comune?: string | null;
  netsuite_id?: string | null;
  address_id?: number | null;
  coes?: string | null;
  taxregime?: string | null;
  is_inactive?: boolean;
  is_blocked?: boolean;
  ingested_at?: string | null;
  created_date?: string | null;
  last_modified_date?: string | null;
  showFullName?: boolean;
  showFullAddress?: boolean;
  showFullProviderName?: boolean;
  showFullEmail?: boolean;
}

export interface ProviderFormData extends Omit<Provider, 'bank_accounts'> {
  bank: string;
  account_number: string;
  account_type: number;
  currency: string;
  role?: string;
}

export interface BankAccount {
  id?: number;
  bank?: string;
  account_number?: string;
  account_type?: number;
  currency?: string;
  is_active: boolean;
}

export interface UserData {
  role: string;
  password?: string;
}

export interface SelectOption {
  label: string;
  value: string;
}

export interface ComuneItem {
  id: number;
  comune: string; // string numérica
  name: string;
}

export interface ProvinceItem {
  id: number;
  city: string; // string numérica
  name: string;
}

export interface CountryItem {
  id: number;
  country: string; // string numérica
  name: string;
}

export interface ApiListResponse<T> {
  items: T[];
}

export type ProviderStatus = 'all' | 'active' | 'inactive' | 'pending';
export type CoesProviderStatus = '' | 'coes' | 'no coes';
